const SESSION_KEY = "ai_chat_session_id";
const DIALOGUE_KEY = "ai_chat_dialogue";

export function getSessionId(): string {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

export function loadDialogue(): { role: "user" | "assistant"; content: string }[] {
  try {
    const raw = sessionStorage.getItem(DIALOGUE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveDialogue(
  dialogue: { role: "user" | "assistant"; content: string }[]
): void {
  sessionStorage.setItem(DIALOGUE_KEY, JSON.stringify(dialogue.slice(-20)));
}

export function clearDialogue(): void {
  sessionStorage.removeItem(DIALOGUE_KEY);
}
